// extracted by mini-css-extract-plugin
export default {"page":"style_page__LTwVe","img":"style_img__57YlM","text":"style_text__004dw","home_btn":"style_home_btn__V3Ulb"};